// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1ZF61","location":"Header_location__6Q1Ma"};